<template>
    <div class="relative flex h-7 w-12 shrink-0 overflow-hidden rounded bg-slate-200 text-slate-400">
        <div class="absolute inset-0 flex">
            <AppIcon name="gamepad-modern" class="m-auto h-4 w-4" />
        </div>

        <img
            v-if="currentSrc"
            :key="currentSrc"
            :src="currentSrc"
            :alt="altText"
            class="relative z-10 h-full w-full object-cover"
            @error="onImageError"
        />
    </div>
</template>

<script>
import { getGameThumbnailUrl } from '@/utils/gameThumbnails'

export default {
    name: 'GameThumbnail',

    props: {
        platform: {
            type: String,
            default: null,
        },
        gameId: {
            type: [String, Number],
            default: null,
        },
        gameName: {
            type: String,
            default: '',
        },
        thumbnailPlatform: {
            type: String,
            default: null,
        },
        thumbnailGameId: {
            type: [String, Number],
            default: null,
        },
        thumbnailSize: {
            type: String,
            default: 'default',
        },
        thumbnailUrl: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            currentSrc: null,
            currentSource: null,
        }
    },

    computed: {
        altText() {
            if (this.gameName) return `${this.gameName} thumbnail`
            return 'Game thumbnail'
        },

        resolvedPlatform() {
            return this.thumbnailPlatform || this.platform
        },

        resolvedGameId() {
            return this.thumbnailGameId || this.gameId
        },

        resolvedThumbnailUrl() {
            return getGameThumbnailUrl({
                platform: this.resolvedPlatform,
                gameId: this.resolvedGameId,
                thumbnailSize: this.thumbnailSize,
            })
        },
    },

    watch: {
        thumbnailUrl: 'resetThumbnail',
        resolvedPlatform: 'resetThumbnail',
        resolvedGameId: 'resetThumbnail',
        thumbnailSize: 'resetThumbnail',
        gameName: 'resetThumbnail',
    },

    created() {
        this.resetThumbnail()
    },

    methods: {
        resetThumbnail() {
            if (this.thumbnailUrl) {
                this.currentSource = 'direct'
                this.currentSrc = this.thumbnailUrl
                return
            }

            this.currentSource = 'builder'
            this.currentSrc = this.resolvedThumbnailUrl
        },

        onImageError() {
            if (this.currentSource === 'direct' && this.resolvedThumbnailUrl) {
                this.currentSource = 'builder'
                this.currentSrc = this.resolvedThumbnailUrl
                return
            }

            this.currentSource = null
            this.currentSrc = null
        },
    },
}
</script>
